import {SapStatusCode, ShiftEvent} from '@hconnect/common/types'
import {Moment} from 'moment'

export const hasMaintenanceNotificationCreationTimedOut = (
  item: Partial<ShiftEvent>,
  now: Moment
) =>
  Boolean(item.lastMaintenanceNotificationCreationStart) &&
  (!item.sapStatusCode || item.sapStatusCode === SapStatusCode.SUBMITTED) &&
  item.lastMaintenanceNotificationCreationStart?.clone().add(10, 'minutes').isBefore(now)
